import { Text } from '@shieldpay/bumblebee/text';

const getLoremIpsum = ({
  paragraphCount = 1,
  maxWords,
}: {
  paragraphCount?: number;
  maxWords?: number;
}) => {
  const words = [
    'lorem',
    'ipsum',
    'dolor',
    'sit',
    'amet',
    'consectetur',
    'adipiscing',
    'elit',
    'sed',
    'do',
    'eiusmod',
    'tempor',
    'incididunt',
    'ut',
    'labore',
    'et',
    'dolore',
    'magna',
    'aliqua',
    'ut',
    'enim',
    'ad',
    'minim',
    'veniam',
    'quis',
    'nostrud',
    'exercitation',
    'ullamco',
    'laboris',
    'nisi',
    'ut',
    'aliquip',
    'ex',
    'ea',
    'commodo',
    'consequat',
    'duis',
    'aute',
    'irure',
    'dolor',
    'in',
    'reprehenderit',
    'in',
    'voluptate',
    'velit',
    'esse',
    'cillum',
    'dolore',
    'eu',
    'fugiat',
    'nulla',
    'pariatur',
    'excepteur',
    'sint',
    'occaecat',
    'cupidatat',
    'non',
    'proident',
    'sunt',
    'in',
    'culpa',
    'qui',
    'officia',
    'deserunt',
    'mollit',
    'anim',
    'id',
    'est',
    'laborum',
  ];

  return Array.from({ length: paragraphCount }, () => {
    const wordCount = Math.min(
      Math.floor(Math.random() * 25) + 21,
      words.length,
    );

    return words
      .slice(maxWords ? wordCount - maxWords : 0, wordCount)
      .join(' ');
  });
};

export const RandomText = ({
  paragraphCount,
  maxWords,
}: Partial<{
  paragraphCount: number;
  maxWords: number;
}>) => {
  const paragraphs = getLoremIpsum({ paragraphCount, maxWords });

  return (
    <>
      {paragraphs.map((paragraph) => (
        <Text key={paragraph}>{paragraph}</Text>
      ))}
    </>
  );
};
